import { render, staticRenderFns } from "./UserViewUserInfoCard.vue?vue&type=template&id=407247b2&scoped=true&"
import script from "./UserViewUserInfoCard.vue?vue&type=script&lang=js&"
export * from "./UserViewUserInfoCard.vue?vue&type=script&lang=js&"
import style0 from "./UserViewUserInfoCard.vue?vue&type=style&index=0&id=407247b2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "407247b2",
  null
  
)

export default component.exports